import { ForrigeBokWork, getRawForrigebokReadalikes } from "./api";
import { Site } from "@libry-content/types";
import { sift } from "radash";
import {
  SiteSearchConfig,
  getSearchConfig,
} from "../../../../apps/frontend/src/searchAndCollection/searchApi/searchConfig";
import { getWorks } from "../../../../apps/frontend/src/searchAndCollection/searchApi/searchWorks";
import { Work } from "@biblioteksentralen/cordata";

export const getForrigebokReadalikesFilteredOnCatalogue = async (config: {
  site: Site;
  workId?: string;
  isbn?: string;
  termIds?: string[];
  limit: number;
}): Promise<Work[] | undefined> => {
  const { workId, isbn, termIds, limit } = config;

  const rawdataLimit = Math.min(limit + 4, 20); // Fetch 4 extra to account for missing entries, maxing at 20 which is forrigeboks hard limit
  const finalLimit = limit;

  const { readalikes } = await getRawForrigebokReadalikes({ workId, isbn, termIds, limit: rawdataLimit });

  if (!readalikes?.length || !config.site) return [];

  return filterAndTransformForrigebokWorks(readalikes, config.site, finalLimit);
};

const filterAndTransformForrigebokWorks = async (
  readalikes: ForrigeBokWork[],
  site: Site,
  limit: number
): Promise<Work[] | undefined> => {
  const searchConfig = getSearchConfig(site);

  if (searchConfig?.isSearchIntegrationEnabled) {
    const bmdbReadalikes = transformForrigebokWorksToBMDBWorkAndRemoveMissingEntries(readalikes, searchConfig);
    return (await bmdbReadalikes).slice(0, limit);
  }

  return undefined;
};

const transformForrigebokWorksToBMDBWorkAndRemoveMissingEntries = async (
  forrigeBokWorks: ForrigeBokWork[],
  siteSearchConfig: SiteSearchConfig
) => {
  const forrigeBokWorkIds = forrigeBokWorks.map(({ id }) => id);
  const bmdbWorks = await getWorks(siteSearchConfig, forrigeBokWorkIds);

  return sift(
    forrigeBokWorks.map((forrigebokWork) => bmdbWorks.find((bmdbWork) => bmdbWork.id === forrigebokWork.id)) // Må mappe fra forrigebokworks for å beholde riktig rekkefølge
  );
};
